import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'

import type Review from 'modules/reviews/store/models/v2/Review'

import DeleteAuthorAsEditorModal from './DeleteAuthorAsEditorModal'

interface Props {
  userIsAuthor: boolean
  supervisorId: number
  review: Review
}

const EditorRightActions = ({ userIsAuthor, supervisorId, review }: Props) => {
  const [deleteModalOpen, toggleDeleteModal] = useToggle(false)
  const api = apiClient()
  const { running, performAction: onDeleteEditor } = useAsyncAction(async () => {
    await api.del(`/performance_reviews/reviews/${review.attributes.id}/supervisors`, {
      // TODO: double check
      access_id: supervisorId,
      form_id: review.attributes.id,
    })
    review.fetch()
  })

  return (
    <>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <PopoverMenu.TouchableOption
            title={i18n.t('surveys.form.participants.table.body.edit.delete.review')}
            disabled={running}
            onClick={userIsAuthor ? toggleDeleteModal(true) : () => onDeleteEditor()}
          />
        </PopoverMenu.Content>
      </PopoverMenu>
      {deleteModalOpen && (
        <DeleteAuthorAsEditorModal
          review={review}
          supervisorId={supervisorId}
          onClose={toggleDeleteModal(false)}
        />
      )}
    </>
  )
}

export default observer(EditorRightActions)
